import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import {
  ContentTabsItem,
  ContentTabsList /* Section, */,
  ContentWrap,
  IncludeContent,
  SectionGroup,
} from 'bricks';
import { isScreenBelow800 } from 'store/common/settings/breakpoint/selectors';
import { DELIVERY_TYPE_COURIER, DELIVERY_TYPE_TAKEAWAY } from 'store/constants';
import { setActiveDeliverySectionWithHash } from 'store/ProductDetails/common/actions';
import {
  getActiveDeliverySection,
  getDeliveryHeadline,
  getDeliveryOfficesCount,
  getDeliveryTypes,
} from 'store/ProductDetails/selectors';
import commonStyles from 'styles/common.pcss';
import { formatPriceExtended } from 'utils/formatting';

import DeliveryTypeTakeaway from './components/DeliveryTypeTakeaway';
import { deliveryTabViewBuilder } from './helpers';
import styles from './styles.pcss';

const cx = classNames.bind({ ...commonStyles, ...styles });

/**
 * Slug based router for delivery type contents
 */
const DeliveryTypeSwitch = ({ content, slug }) => {
  switch (slug) {
    case DELIVERY_TYPE_COURIER:
      return <IncludeContent htmlContent={content} />;
    case DELIVERY_TYPE_TAKEAWAY:
      return (
        <DeliveryTypeTakeaway>
          <IncludeContent htmlContent={content} />
        </DeliveryTypeTakeaway>
      );
    default:
      return null;
  }
};

DeliveryTypeSwitch.propTypes = {
  content: PropTypes.string,
  slug: PropTypes.string,
};

// TODO need refactoring
const DeliveryTab = ({
  deliverySection,
  headline,
  isMobile,
  offices,
  onSetActiveDeliverySection,
  tabs,
}) => {
  const { tabsToRender } = deliveryTabViewBuilder(tabs, offices);
  const tabToRender = tabsToRender.find(({ slug }) => slug === deliverySection);
  const onSetTabType = useCallback(
    (tabSlug, tabTitle) => () => onSetActiveDeliverySection(tabSlug, tabTitle),
    [],
  );

  return (
    <div className={cx('component')}>
      <ContentWrap size={['xl']}>
        <SectionGroup>
          <div className={cx('delivery', isMobile && 'mobile')}>
            <div className={cx('header', isMobile && 'mobile')}>{headline}</div>
            <div className={cx('tabsWrapper')}>
              <ContentTabsList className={cx('tabs', 'padb-m')}>
                {tabsToRender.map(({ price, slug, title }) => (
                  <ContentTabsItem
                    isActive={slug === deliverySection}
                    isMobile={isMobile}
                    key={slug}
                    onClick={onSetTabType(slug, title)}
                    postfix={formatPriceExtended(price)}
                  >
                    {title}
                  </ContentTabsItem>
                ))}
              </ContentTabsList>
            </div>
            <DeliveryTypeSwitch
              content={(tabToRender || {}).content || ''}
              slug={deliverySection}
            />
          </div>
        </SectionGroup>
      </ContentWrap>
    </div>
  );
};

DeliveryTab.propTypes = {
  deliverySection: PropTypes.string,
  headline: PropTypes.string,
  isMobile: PropTypes.bool,
  offices: PropTypes.number,
  onDeliveryTypeChange: PropTypes.func,
  onSetActiveDeliverySection: PropTypes.func,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string,
      isDefault: PropTypes.bool,
      price: PropTypes.number,
      slug: PropTypes.string,
      title: PropTypes.string,
      url: PropTypes.string,
    }),
  ),
};

const mapStateToProps = (state) => ({
  deliverySection: getActiveDeliverySection(state),
  headline: getDeliveryHeadline(state),
  isMobile: isScreenBelow800(state),
  offices: getDeliveryOfficesCount(state),
  tabs: getDeliveryTypes(state),
});

const mapDispatchToProps = {
  onSetActiveDeliverySection: setActiveDeliverySectionWithHash,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryTab);
